import SiafLiteApiRepository from "../../external/siafLiteApi";

class CsoSimplesService {
  constructor() {
    this.urlBase = "/fiscal/cso-simples";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default CsoSimplesService;
